// extracted by mini-css-extract-plugin
export default {"root":"FormWindow_root__XGdGH"};